import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import _ from 'underscore';
import BreadCrumbs from './BreadCrumbs';
import MapView from './MapView';

import config from './../config';

class SyslurListView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/geoleit/?type=farm&limit=15000';

		this.state = {
			data: [],
			formData: {},
			activeFilters: [],
			currentSearch: ''
		}

		this.inputChangeHandler = this.inputChangeHandler.bind(this);
		this.filterMap = this.filterMap.bind(this);

		this.filters = {
			'label': {
				label: 'Heiti'
			},
			'tegund_id': {
				label: 'Tegund',
				store: 'tegundir'
			},
			'hreppur_id': {
				label: 'Hreppur',
				store: 'hreppar'
			},
			'sysla_id': {
				label: 'Sýsla',
				store: 'syslur'
			},
			'greinar': {
				label: 'Greinar'
			}
		}
	}

	inputChangeHandler(event) {
		let formData = this.state.formData;
		
		if (event.target.type == 'checkbox') {
			formData[event.target.name] = event.target.checked;
		}
		else {
			formData[event.target.name] = event.target.value == '' ? false : event.target.value;
		}

		this.setState({
			formData: formData
		});
	}

	filterMap() {
		let activeFilters = [];

		Object.keys(this.state.formData).forEach((filter, i) => {
			if (this.state.formData[filter]) {
				activeFilters.push({
					filter: filter,
					value: this.state.formData[filter]
				});
			}
		});

		this.props.history.push({
			pathname: this.props.history.location.pathname,
			search: activeFilters.map((item) => item.filter+'='+item.value).join('&')
		});
	}

	updateMap() {
		let mapData = this.state.originalData;

		let formData = {};

		if (this.props.history.location.search != '') {
			this.props.history.location.search.replace('?', '').split('&').map((item) => {
				let frags = item.split('=');

				formData[frags[0]] = decodeURI(frags[1]);
			});
		}

		let activeFilters = [];

		Object.keys(formData).forEach((filter, i) => {
			if (formData[filter]) {
				activeFilters.push({
					filter: filter,
					value: formData[filter]
				});

				mapData = _.filter(mapData, (item => {
					if (filter == 'tegund_id') {
						return item.tegund.id == formData[filter];
					}
					else if (filter.indexOf('_id') > -1) {
						return item[filter] == formData[filter];
					}
					else if (filter == 'greinar') {
						return item.article_count > 0;
					}
					else {
						return item[filter] ? item[filter].startsWith(formData[filter]) : false;
					}
				}));
			}
		});

		this.setState({
			data: mapData,
			activeFilters: activeFilters,
			formData: formData
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		if (this.props.history.location.search != this.state.currentSearch) {
			this.setState({
				currentSearch: this.props.history.location.search
			});
			this.updateMap();
		}
	}

	fetchData() {
		fetch(this.url)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				let hrepparIndex = {};
				let hreppar = [];
				let syslurIndex = {};
				let syslur = [];
				let tegundirIndex = {};
				let tegundir = [];

				let mapData = json.results.map(item => {
					if (!hrepparIndex[item.hreppur_id]) {
						hrepparIndex[item.hreppur_id] = item.hreppur;
						hreppar.push({
							id: item.hreppur_id,
							name: item.hreppur
						});
					}

					if (!syslurIndex[item.sysla_id]) {
						syslurIndex[item.sysla_id] = item.sysla;
						syslur.push({
							id: item.sysla_id,
							name: item.sysla
						});
					}

					if (!tegundirIndex[item.tegund_id]) {
						tegundirIndex[item.tegund_id] = item.tegund;
						tegundir.push({
							id: item.tegund_id,
							name: item.tegund
						});
					}

					return {
						id: item.id,
						ornefnaskra_id: item.ornefnaskra,
						label: item.name,
						type: item.type,
						latLng: [item.lat, item.lng],
						district: (item.hreppur ? item.hreppur+', ' : '')+item.sysla,
						tegund: {
							id: item.tegund_id,
							tegund: item.tegund
						},
						hreppur_id: item.hreppur_id,
						sysla_id: item.sysla_id,
						article_count: item.article_count
					}
				});

				hreppar = hreppar.sort(function (a, b) {
					return a.name && b.name ? a.name.localeCompare(b.name) : 0;
				});

				syslur = syslur.sort(function (a, b) {
					return a.name && b.name ? a.name.localeCompare(b.name) : 0;
				});

				tegundir = tegundir.sort(function (a, b) {
					return a.name && b.name ? a.name.localeCompare(b.name) : 0;
				});

				this.setState({
					originalData: mapData,
					data: mapData,
					hreppar: hreppar,
					syslur: syslur,
					tegundir: tegundir
				});
			}.bind(this));
	}

	render() {
		return (
			<div className={'row boxes'}>

				<div className={'col col-12'}>
					<div className="column-content full-screen">
						<MapView mapData={this.state.data} className="full">
							{
								this.state.currentSearch.indexOf('greinar=') == -1 && <div>
									<h6>Kortaleit</h6>
									<div className="form-inline">

										<input placeholder="Heiti" type="text" className="form-control" name="label" value={this.state.formData['label'] || ''} onChange={this.inputChangeHandler} />

										<select className="form-control" name="tegund_id" value={this.state.formData['tegund_id'] || ''} onChange={this.inputChangeHandler}>
											<option value="">Allar tegundir</option>
											{
												this.state.tegundir && this.state.tegundir.map((item, index) => <option key={index} value={item.id}>{item.name}</option>)
											}
										</select>

										<select className="form-control" name="hreppur_id" value={this.state.formData['hreppur_id'] || ''} onChange={this.inputChangeHandler}>
											<option value="">Allir hreppar</option>
											{
												this.state.hreppar && this.state.hreppar.map((item, index) => <option key={index} value={item.id}>{item.name}</option>)
											}
										</select>

										<select className="form-control" name="sysla_id" value={this.state.formData['sysla_id'] || ''} onChange={this.inputChangeHandler}>
											<option value="">Allar sýslur</option>
											{
												this.state.syslur && this.state.syslur.map((item, index) => <option key={index} value={item.id}>{item.name}</option>)
											}
										</select>

										{
											/*
											<label><input className="form-control" style={{marginRight: 10}} type="checkbox" name="greinar" checked={this.state.formData['greinar']} onChange={this.inputChangeHandler} />Tengdar greinar</label>
											*/
										}

										<button className="btn btn-primary" onClick={this.filterMap}>Leita</button>

									</div>
									{
										this.state.activeFilters.length > 0 &&
										<div style={{
											marginTop: 10,
											textAlign: 'right'
										}}>
											<div style={{
												display: 'inline-block',
												marginRight: 20
											}}>
												{
													this.state.activeFilters.map((item, index) => {
														return <span><strong>{this.filters[item.filter].label}</strong>: {this.filters[item.filter].store ? _.findWhere(this.state[this.filters[item.filter].store], {id: parseInt(item.value)}).name : (item.value == 'true' ? 'Já' : item.value)} </span>
													})
												}
											</div>
											<button className="btn btn-secondary" onClick={() => this.props.history.push({
												pathname: this.props.history.location.pathname,
												search: ''
											})}>Sýna allt</button>
										</div>
									}
								</div>
							}
						</MapView>
					</div>
				</div>

			</div>
		);
	}
}

export default withRouter(SyslurListView);



// WEBPACK FOOTER //
// ./src/components/BrowseMapView.js